module.exports = __webpack_public_path__ + "img/ta_askfor_xp.5e57800f.png";